const replaceBrackets = (text: string) =>
  text.replace(/(&lt;)/g, '<').replace(/&gt;/g, '>')

export default replaceBrackets
